/**
 * uniqueConfigName — a configuration name that no existing configuration in
 * the org already uses: the base name, else "Base (2)", "Base (3)", …
 *
 * Used by History → Save as configuration, so saving the same run twice
 * gives two distinguishable configurations. Names compare trimmed and
 * case-insensitively; a base that already ends in " (N)" counts from there.
 */
export function uniqueConfigName(base: string, existingNames: string[]): string {
  const taken = new Set(existingNames.map((n) => n.trim().toLowerCase()));
  const trimmed = base.trim() || 'Untitled configuration';
  if (!taken.has(trimmed.toLowerCase())) return trimmed;

  const m = trimmed.match(/^(.*) \((\d+)\)$/);
  const stem = m ? m[1] : trimmed;
  let n = m ? Number(m[2]) + 1 : 2;
  while (taken.has(`${stem} (${n})`.toLowerCase())) n++;
  return `${stem} (${n})`;
}
